import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Markdown from 'react-markdown';
import gfm from 'remark-gfm';
import config from '../../config';
import { useTranslation } from 'react-i18next';

const Condition = (props) => {
  const { t, i18n } = useTranslation();
  const [pageData, setPageData] = useState({ title: { fr: '', ar: '' }, description: { fr: '', ar: '' } });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const id = location.pathname.split('/').pop();

  // Déterminer la direction en fonction de la langue
  const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

  const findCondition = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${config.SITE_API_URL}/page/${id}`,
        { headers: { 'x-api-key': config.SITE_API_KEY } }
      );
      console.log('API response:', response.data); // Pour déboguer
      const { title, description } = response.data.result || {};
      setPageData({
        title: {
          fr: title?.fr || '',
          ar: title?.ar || '',
        },
        description: {
          fr: description?.fr || '',
          ar: description?.ar || '',
        },
      });
    } catch (error) {
      console.error('Error fetching condition:', error);
      setError(error.message);
      toast.error(<b>{t('errors.fetch_condition_error', { error: error.message })}</b>);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    findCondition();
  }, [id]);

  // Définir les styles pour chaque niveau de titre avec prise en charge de RTL
  const markdownComponents = {
    h1: ({ node, ...props }) => (
      <h1 className="text-darkgray text-3xl font-bold" style={{ textAlign: direction === 'rtl' ? 'right' : 'left' }} {...props} />
    ),
    h2: ({ node, ...props }) => (
      <h2 className="text-[#232323] text-xxl" style={{ textAlign: direction === 'rtl' ? 'right' : 'left' }} {...props} />
    ),
    h3: ({ node, ...props }) => (
      <h3 className="text-blue-600 font-medium" style={{ textAlign: direction === 'rtl' ? 'right' : 'left' }} {...props} />
    ),
    h4: ({ node, ...props }) => (
      <h4 className="text-red-600 text-lg font-normal" style={{ textAlign: direction === 'rtl' ? 'right' : 'left' }} {...props} />
    ),/* 
    p: ({ node, ...props }) => (
      <p className="text-gray-700" style={{ textAlign: direction === 'rtl' ? 'right' : 'left' }} {...props} />
    ), */
  };

  return (
    <div className="bg-gray-50" style={{ ...props.style, direction: direction }}>
      <ToastContainer position={direction === 'rtl' ? 'bottom-right' : 'bottom-left'} rtl={direction === 'rtl'} />
      <Container className="mt-20 p-20">
        <div className="w-75 mx-auto bg-white rounded-lg shadow-md p-10 text-gray-700">
          {loading ? (
          <p>{t('loading')}</p>
        ) : error ? (
          <p className="text-red-500">{t('errors.error', { error })}</p>
        ) : (
          <>
            <div className="text-xl uppercase text-center">
              {pageData.title[i18n.language] ? (
                <h1 className='text-center'>
                  <Markdown remarkPlugins={[gfm]} components={markdownComponents}>
                  {pageData.title[i18n.language]}
                </Markdown>
                </h1>
              ) : (
                <p>{t('errors.title_not_available')}</p>
              )}
            </div>
            <div className="mt-4">
              {pageData.description[i18n.language] ? (
                <Markdown remarkPlugins={[gfm]} components={markdownComponents}>
                  {pageData.description[i18n.language]}
                </Markdown>
              ) : (
                <p>{t('errors.description_not_available')}</p>
              )}
            </div>
          </>
        )}
        </div>
      </Container>
    </div>
  );
};

export default Condition;